import React, { Component } from 'react';

class Header extends Component {

    state = {
        initialState: '',
        logo: 'Merchant LOGO'
    }

    render() {
        return(
            <React.Fragment>
                <header>
                    <div className="container-fluid">
                        <figcaption>
                        <h1>
                           <p className="mb-0">

                           <img className="merchantLogo" src={this.props.merchantLogo} alt="Logo" />
                                {this.props.merchantName && <span>{this.props.merchantName}</span>}
                           </p>
                              
                           
                            {/* <h1><img className="merchantLogo" src={this.props.merchantLogo} alt="Logo" /> */}
                           
                            </h1>
                        </figcaption>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

export default Header;